var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconComponent)?_c('span',_vm._g(_vm._b({staticClass:"app-icon",style:(_vm.iconStyle)},'span',_vm.$attrs,false),_vm.$listeners),[_c(_vm.iconComponent,{tag:"component",attrs:{"size":_vm.size}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }